import { Tooltip } from 'bootstrap';

class CopyToClipboard {
  constructor (element) {
    this.element = element;
  }

  static addClipboardCopier (element, tooltip) {
    element.addEventListener('click', evt => {
      evt.stopPropagation();
      evt.preventDefault();

      let elementText = element.getAttribute('data-bs-original-title');
      let copytext = element.getAttribute('data-copy-text');
      console.log(copytext);

      if (!navigator.clipboard) {
        var textArea = document.createElement("textarea");
        textArea.value = copytext;

        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);

        textArea.focus();
        textArea.select();

        try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'successful' : 'unsuccessful';
          console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
      } else {
        navigator.clipboard.writeText(copytext).then(function () {
          console.log('Async: Copying to clipboard was successful!');
        }, function (err) {
          console.error('Async: Could not copy text: ', err);
        });
      }

      tooltip.setContent({
        '.tooltip-inner': 'kopiert'
      });

      window.setTimeout(() => {
        tooltip.setContent({
          '.tooltip-inner': elementText
        });
      }, 3000);
    })
  }

  init() {
    this.tooltip = new Tooltip(this.element);
    this.constructor.addClipboardCopier(this.element, this.tooltip);
    // this.tooltip.show();
  }
}

export default CopyToClipboard;
